import { Component, OnInit } from '@angular/core';
import { IHelp } from '@ebb-v2/ebb-integration';

import { HelpApiService } from 'libs/ebb-integration/src/lib/services/data/help-api.service';

@Component({
    selector: 'ebb-no-policy',
    templateUrl: './no-policy.component.html',
    styleUrls: ['./no-policy.component.scss'],
    standalone: false
})
export class NoPolicyComponent implements OnInit {

  public listHelp: IHelp[] = [];
  public message: string;
  public showMessage:boolean =false;
  constructor( private readonly apiHelp: HelpApiService) { }
  ngOnInit() {
    this.loadHelpText();
  }
  private loadHelpText(): void {
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = JSON.parse(JSON.stringify(data));
          const indexHelpContractor = this.listHelp.findIndex(i => i.name.toLowerCase() === 'ceabbregistrationpolicynotfound');
          this.message = this.listHelp[indexHelpContractor] ? this.listHelp[indexHelpContractor].answer : 
            "<h2>Information Not Found.</h2>The entered information does not match our records, please contact customer service for further assistance. (800) 584-2658";
          this.showMessage = true;
        },
        error => console.log(error)
      );
  }
}
